module.exports = __webpack_public_path__ + "img/nike-talk-2.b418ce60.jpg";